function daysSinceHarvest(harvestDate) {
  const harvest = new Date(harvestDate);
  const today = new Date();

  // remove time so difference is date-based only
  harvest.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const diffMs = today - harvest;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  return diffDays + 1;
}

export default daysSinceHarvest;
